export default __webpack_public_path__ + "static/media/PolarisAfternoon.2b6591b0.mp3";